import { render, staticRenderFns } from "./ShpsList.vue?vue&type=template&id=1fa969b8&scoped=true&"
import script from "./ShpsList.vue?vue&type=script&lang=js&"
export * from "./ShpsList.vue?vue&type=script&lang=js&"
import style0 from "./ShpsList.vue?vue&type=style&index=0&id=1fa969b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa969b8",
  null
  
)

export default component.exports